var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "인재채용",
      "tabActive": "채용 FAQ",
      "bg": "/images/sub/visual/sv4-6.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(" 채용 FAQ ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 여러분의 궁금증을 풀어드립니다. ")])]), _c('faq-list', {
    attrs: {
      "type": _vm.filter.type
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }